module.exports = __webpack_public_path__ + "media/vid_body_feature4.917e624b.mp4";